import React, { useEffect } from 'react';

// Support / contact email (display-only, rendered as a mailto: link).
const SUPPORT_EMAIL = 'destek@pandaprop.tech';

const faqs = [
  {
    q: 'Hesaba giriş sorunları',
    a: 'Kullanıcı adı veya şifrenizle giriş yapamıyorsanız, bilgilerinizi doğru girdiğinizden emin olun. Şifrenizi unuttuysanız giriş ekranındaki “Şifremi Unuttum” adımını kullanarak e-posta ile sıfırlayabilirsiniz. Sorun devam ederse yöneticinizle veya bizimle iletişime geçin.',
  },
  {
    q: 'Aidat ve borç bilgilerinin görüntülenmesi',
    a: 'Aidat, diğer ödemeler ve kalan borcunuzu “Ana Sayfa” ve “Aidatlar” ekranlarından görüntüleyebilirsiniz. Malik iseniz kiracınıza ait aidat borcu size yalnızca bilgi amaçlı (salt okunur) gösterilir ve sizin ödenecek tutarınıza dahil edilmez.',
  },
  {
    q: 'Ödeme işlemleri',
    a: 'Ödemeleriniz apartman yönetimi tarafından sisteme işlenir. Yaptığınız bir ödeme ekranlarınıza yansımadıysa, ödeme tarihi ve tutarıyla birlikte bizimle veya yöneticinizle iletişime geçin.',
  },
  {
    q: 'Malik veya kiracı bilgilerindeki hatalar',
    a: 'Dairenizin malik/kiracı tanımı hatalıysa veya eksikse, bu tanımlar apartman yönetimi tarafından düzenlenir. Doğru bilgileri belirterek yöneticinize veya destek adresimize bildirebilirsiniz.',
  },
  {
    q: 'Duyurular ve bildirimler',
    a: 'Yönetim tarafından paylaşılan duyuruları “Ana Sayfa” ekranındaki Duyurular bölümünden takip edebilirsiniz.',
  },
  {
    q: 'Diğer teknik sorunlar',
    a: 'Uygulamanın açılmaması, ekranların yüklenmemesi veya beklenmedik hatalar için; kullandığınız cihaz ve uygulama sürümü ile birlikte durumu bize iletin. Mümkünse bir ekran görüntüsü eklemeniz çözümü hızlandırır.',
  },
];

const tips = [
  'Adınız, apartman/site adınız ve daire numaranız',
  'Yaşadığınız sorunun kısa açıklaması',
  'Varsa ilgili ekranın görüntüsü (ekran görüntüsü)',
  'Kullandığınız cihaz (iPhone/Android) ve uygulama sürümü',
];

export const SupportPage = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'PandaProp Destek';
    let meta = document.querySelector('meta[name="description"]');
    let created = false;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
      created = true;
    }
    const prevDesc = meta.getAttribute('content');
    meta.setAttribute(
      'content',
      'PandaProp uygulamasıyla ilgili soru, görüş ve destek talepleriniz için bizimle iletişime geçebilirsiniz.'
    );
    return () => {
      document.title = prevTitle;
      if (created && meta.parentNode) meta.parentNode.removeChild(meta);
      else if (meta && prevDesc != null) meta.setAttribute('content', prevDesc);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-blue-50 to-indigo-50 flex flex-col" data-testid="support-page">
      {/* Header */}
      <header className="w-full border-b border-gray-200/70 bg-white/60 backdrop-blur-sm">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src="/assets/pandaprop-logo.png" alt="PandaProp" className="h-11 sm:h-14 w-auto" />
          </a>
          <a
            href="/"
            className="text-sm font-semibold text-teal-700 hover:text-teal-800 transition-colors"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Ana Sayfa
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <div className="container mx-auto px-4 py-12 sm:py-16">
          <div className="max-w-3xl mx-auto">
            {/* Title */}
            <div className="text-center mb-10">
              <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                PandaProp Destek
              </h1>
              <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
                PandaProp uygulamasıyla ilgili soru, görüş ve destek talepleriniz için bizimle iletişime geçebilirsiniz.
              </p>
            </div>

            {/* Quick contact banner */}
            <section className="bg-teal-600 rounded-2xl shadow-lg p-6 sm:p-8 mb-6 text-white">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                  <h2 className="text-lg sm:text-xl font-bold mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    Bize ulaşın
                  </h2>
                  <p className="text-sm text-teal-50" style={{ fontFamily: 'Inter, sans-serif' }}>
                    Destek taleplerinizi genellikle 1-2 iş günü içinde yanıtlıyoruz.
                  </p>
                </div>
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  data-testid="support-email"
                  className="inline-flex items-center justify-center px-5 py-3 bg-white text-teal-700 rounded-full font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {SUPPORT_EMAIL}
                </a>
              </div>
            </section>

            {/* PandaProp Hakkında */}
            <section className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 sm:p-8 mb-6">
              <h2 className="text-xl sm:text-2xl font-bold text-teal-700 mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                PandaProp Hakkında
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                PandaProp, apartman ve site sakinlerinin aidat, borç, ödeme, duyuru ve daireleriyle ilgili bilgilere
                kolayca erişmesini sağlayan dijital bir platformdur.
              </p>
              <p className="text-base text-gray-700 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                Sakin uygulaması ile aylık aidat durumunuzu takip edebilir, kalan borcunuzu ve ödeme geçmişinizi
                görüntüleyebilir, apartmanın mali özetine ulaşabilir ve yönetim duyurularını takip edebilirsiniz.
                Malik ve kiracı ayrımı sayesinde her sakin yalnızca kendisini ilgilendiren borçları görür.
              </p>
            </section>

            {/* Destek */}
            <section className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 sm:p-8 mb-6">
              <h2 className="text-xl sm:text-2xl font-bold text-teal-700 mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Destek
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                Uygulamayı kullanırken yaşadığınız sorunlar veya sorularınız için bizimle iletişime geçebilirsiniz.
              </p>
              <div className="flex flex-wrap items-center gap-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                <span className="text-sm font-semibold text-gray-800">E-posta:</span>
                <a href={`mailto:${SUPPORT_EMAIL}`} className="text-teal-700 font-semibold hover:text-teal-800 underline">
                  {SUPPORT_EMAIL}
                </a>
              </div>
            </section>

            {/* Destek talebi oluştururken */}
            <section className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 sm:p-8 mb-6">
              <h2 className="text-xl sm:text-2xl font-bold text-teal-700 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Destek Talebi Oluştururken
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                Talebinizi daha hızlı çözebilmemiz için lütfen aşağıdaki bilgileri e-postanıza ekleyin:
              </p>
              <ul className="space-y-3" style={{ fontFamily: 'Inter, sans-serif' }}>
                {tips.map((tip) => (
                  <li key={tip} className="flex items-start gap-3 text-gray-700">
                    <span className="text-teal-500 mt-0.5">✓</span>
                    <span className="text-base">{tip}</span>
                  </li>
                ))}
              </ul>
            </section>

            {/* Sık Karşılaşılan Konular (FAQ) */}
            <section className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 sm:p-8">
              <h2 className="text-xl sm:text-2xl font-bold text-teal-700 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Sık Karşılaşılan Konular
              </h2>
              <div className="divide-y divide-gray-100">
                {faqs.map((item) => (
                  <div key={item.q} className="py-4 first:pt-0 last:pb-0">
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                      {item.q}
                    </h3>
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                      {item.a}
                    </p>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full border-t border-gray-200/70 bg-white/60 backdrop-blur-sm">
        <div className="container mx-auto px-4 py-6 text-center text-sm text-gray-500" style={{ fontFamily: 'Inter, sans-serif' }}>
          <div className="mb-1">
            PandaProp Destek ·{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-teal-700 hover:text-teal-800 underline">
              {SUPPORT_EMAIL}
            </a>
          </div>
          © {new Date().getFullYear()} PandaProp
        </div>
      </footer>
    </div>
  );
};

export default SupportPage;
